var Backbone = require("backbone");
var Livingplace = require("./livingplace");

var livingplaces = Backbone.Collection.extend({
  model: Livingplace
});

var lps = new livingplaces;

lps.on("add", function(ship) {
	  //alert("Ahoy " + ship.get("xy") + "!");
	});


lps.on("remove", function(lpsrm) {
	  if (lpsrm.get("feature") && lpsrm.get("layerSource")) {
		  var f = lpsrm.get("feature");
		  var s = lpsrm.get("layerSource");
		  s.removeFeature(f);
	  }
	});

module.exports = lps;


// WEBPACK FOOTER //
// ./src/models/livingplacecoll.js